<template lang="pug">
  nav
    .step3_title_area
      .left_image
        img(:src="imagePath + 'img/left_peaple.png'")
      .text {{title}}
      .right_image
        img(:src="imagePath + 'img/right_peaple.png'")
</template>

<script lang="js">
export default {
  computed: {
    imagePath() {
      return process.env.BASE_URL;
    },
  },
  props: {
    mode: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="sass" scoped>
nav
  background-image: $stripe-image
  background-repeat: repeat
  width: 100%
  margin-top: -20px
  margin-bottom: 20px
  .step3_title_area
    display: flex
    justify-content: center
    align-items: center
    .left_image, .right_image
      img
        height: 80px
    .text
      color: $main-light-blue
      font-size: 24px
      margin: 0 15px
@media screen and (max-width: $break-header)
  nav
    margin-top: -60px
    padding: 10px 0
    .step3_title_area
      flex-direction: column
      .left_image, .right_image
        img
          height: 40px
      .text
        font-size: 16px
        margin: 0
</style>